import { MoonLoader } from "react-spinners";

function Loader({ loading, color = "#ffffff" }) {
  return (
    <div className="sweet-loading ">
      <MoonLoader color={color} loading={loading} size={40} />
    </div>
  );
}

export default Loader;
